import { Sparkles, Users, TrendingUp, Gift } from "lucide-react";
import { Button } from "../../components/ui/button";
import { usePanelT } from "../../hooks/usePanelT";

export default function PanelAffiliate() {
    const { t } = usePanelT();
    return (
        <div data-testid="panel-affiliate" className="space-y-8">
            <div>
                <h1 className="font-display font-bold text-3xl md:text-4xl tracking-tight">
                    Affiliate
                </h1>
                <p className="text-muted-foreground mt-1.5">
                    {t("af.sub")}
                </p>
            </div>

            <div className="relative rounded-3xl border border-primary/30 bg-card overflow-hidden">
                <div className="absolute inset-0 grid-bg opacity-40 pointer-events-none" />
                <div className="absolute inset-0 noise pointer-events-none" />
                <div className="relative p-10 md:p-14 text-center">
                    <div className="mx-auto w-14 h-14 rounded-2xl bg-primary/15 grid place-items-center mb-5">
                        <Sparkles className="w-7 h-7 text-primary" />
                    </div>
                    <h2 className="font-display font-black text-3xl md:text-4xl tracking-tight">
                        {t("af.soon")}
                    </h2>
                    <p className="text-muted-foreground max-w-xl mx-auto mt-3 leading-relaxed text-sm md:text-base">
                        {t("af.soonText")}
                    </p>

                    <div className="grid sm:grid-cols-3 gap-4 mt-9 max-w-2xl mx-auto">
                        {[
                            {
                                Icon: Users,
                                title: "Bronze",
                                pct: "20%",
                                hint: t("af.bronze"),
                            },
                            {
                                Icon: TrendingUp,
                                title: "Silver",
                                pct: "25%",
                                hint: t("af.silver"),
                            },
                            {
                                Icon: Gift,
                                title: "Gold",
                                pct: "30%",
                                hint: t("af.gold"),
                            },
                        ].map((tier) => (
                            <div
                                key={tier.title}
                                className="rounded-2xl border border-white/10 bg-background/40 p-5 text-left"
                            >
                                <tier.Icon className="w-5 h-5 text-primary mb-3" />
                                <p className="text-[10px] font-mono uppercase tracking-[0.22em] text-muted-foreground">
                                    {tier.title}
                                </p>
                                <p className="font-display font-black text-3xl mt-1">
                                    {tier.pct}
                                </p>
                                <p className="text-[11px] font-mono text-muted-foreground tracking-wide mt-1">
                                    {tier.hint}
                                </p>
                            </div>
                        ))}
                    </div>

                    <Button
                        disabled
                        data-testid="affiliate-waitlist"
                        className="mt-9 bg-primary/30 text-white font-semibold cursor-not-allowed"
                    >
                        {t("af.notify")}
                    </Button>
                </div>
            </div>
        </div>
    );
}
